import Sticky from './sticky';

const install = function(Vue) {
  Vue.directive('Sticky', Sticky);
};

if (window.Vue) {
  Vue.use(install);
}

Sticky.install = install;

export default Sticky;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-sticky-directive/src/index.js
// module id = 1287
// module chunks = 1